export var VERSION = '2.2.3';
//# sourceMappingURL=version.js.map